import "./app.less";

import { useEffect, useState } from "react";
import TagManager from "react-gtm-module";
import { useLocation } from "react-router-dom";

import { useAccountQuery } from "../store/coreApi";
import { isAccessTokenValid } from "../utils";
import { isInternalUser } from "../utils/userHelper";
import usePortalSettings from "./portalSettings/usePortalSettings";

declare const Cookiebot: {
  consent: {
    marketing: boolean;
  };
};

const useAnalytics = () => {
  const location = useLocation();

  const [gtmInitialized, setGtmInitialized] = useState(false);
  const [marketingCookiesAccepted, setMarketingCookiesAccepted] =
    useState(false);

  const { data: account, isSuccess: loggedIn } = useAccountQuery(undefined, {
    skip: !isAccessTokenValid(),
  });

  const { settings } = usePortalSettings();

  const internalUser = isInternalUser(account);

  useEffect((): void => {
    // Push de pagina-wissels naar GTM
    TagManager.dataLayer({
      dataLayer: {
        event: "page_view",
        url: location.pathname,
      },
    });
  }, [location]);

  const googleTagManagerId = settings.google?.tagManagerId;

  useEffect((): void => {
    if (loggedIn && gtmInitialized) {
      TagManager.dataLayer({
        dataLayer: {
          remote_ip: account.ipAddress,
          userId: internalUser ? account.sterInlog.id : account.id,
          userType: account.userType,
        },
      });
    }
  }, [account, loggedIn, internalUser, gtmInitialized]);

  useEffect(() => {
    const cookiebotOnAccept = () => {
      if (Cookiebot.consent.marketing) {
        // Inladen van GTM is afhankelijk van het accepteren van marketing cookies in Cookiebot
        setMarketingCookiesAccepted(true);
      }
    };

    window.addEventListener("CookiebotOnAccept", cookiebotOnAccept);

    return () => {
      window.removeEventListener("CookiebotOnAccept", cookiebotOnAccept);
    };
  }, [gtmInitialized]);

  useEffect((): void => {
    if (marketingCookiesAccepted && googleTagManagerId && !gtmInitialized) {
      setGtmInitialized((value) => {
        if (!value) {
          TagManager.initialize({
            gtmId: `${googleTagManagerId}`,
          });
        }
        return true;
      });
    }
  }, [
    account,
    googleTagManagerId,
    gtmInitialized,
    internalUser,
    loggedIn,
    marketingCookiesAccepted,
  ]);
};

export default useAnalytics;
